module.exports = __webpack_public_path__ + "img/nmg_logo.38c3fb94.svg";